import React, { useEffect, useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { MODULE_API } from "../../../../../apis";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import "./styles/professionalcontacts.css";
import deathApi from "../../../../../apis/death.api";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
export default function ProfessionalContacts(props) {
  const [fields, setFields] = useState({});
  const [tabs, setTabs] = useState([]);
  const [fieldsData, setFieldsData] = useState({});
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [toUpdate, setToUpdate] = useState(false);
  const [contactlist, setContactList] = useState([]);
  const history = useHistory();
  const getAttribute = async (moduleName) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchAttributes(moduleName);
      if (res) {
        res.attributes &&
          res.attributes.map((attribute) => {
            setLoading(false);
            setFields((prevValue) => {
              return {
                ...prevValue,
                [attribute["groupName"]]: {
                  ...(prevValue[attribute["groupName"]] || {}),
                  [attribute["id"]]: attribute,
                },
              };
            });
          });
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    }
  };
  const createAttributes = async () => {
    try {
      setLoading(true);
      await MODULE_API.addAsset("Professional Contacts", {
        clientModules: [formData],
      });
      await fetchData("Professional Contacts");
      setToUpdate(true);
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setFormData(null);
    }
  };
  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(formData.id, {
        ...formData,
      });
      await fetchData(formData.module);
      setLoading(false);
      setFormData(null);
    } catch (error) {
    } finally {
      setFormData(null);
      setLoading(false);
    }
  };
  const getContactsModule = async () => {
    try {
      setLoading(true);
      setContactList([]);
      const apiResponse = await deathApi.getClientContacts();

      if (apiResponse && apiResponse.data) {
        const processedContacts = apiResponse.data.map((contact) => {
          // Trim and handle null/undefined values
          const firstName = (contact.firstName && contact.firstName.trim()) || "";
          const lastName = (contact.lastName && contact.lastName.trim()) || "";

          // Create full name only if at least firstName exists
          let fullName = "";
          if (firstName && lastName) {
            fullName = `${firstName} ${lastName}`;
          } else if (firstName) {
            fullName = firstName;
          } else if (lastName) {
            fullName = lastName;
          } else {
            fullName = (contact.name && contact.name.trim()) || ""; // Fallback to name field
          }

          // Return the full contact object with the calculated fullName
          return {
            fullName: fullName.trim(),
            key: contact.id || Math.random().toString(36).substr(2, 9), // Fallback key if no id
          };
        });

        setContactList(processedContacts);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to load contacts:", error);
      setLoading(false);
    }
  };
  const fetchData = async (moduleName) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      const records = res.records || [];
      console.log("records", records);
      setFieldsData(records[0]);
      setLoading(false);
      return { moduleName, records }; // Return object with moduleName to map later
    } catch (error) {
      console.error(`Error fetching data for ${moduleName}:`, error);
      return { moduleName, records: [] }; // Return empty if failed
    } finally {
      setLoading(false);
    }
  };
  const moduleNames = ["Professional Contacts"];
  const fetchAllModulesData = async () => {
    try {
      setLoading(true);
      const results = await Promise.all(moduleNames.map((name) => fetchData(name)));
      console.log("All module results:", results);
      const professionalContact = results.find((item) => item.moduleName === "Professional Contacts");
      if (professionalContact) {
        const targetRecord = professionalContact.records.find((record) => record.subType === "Disability");
        console.log("targetRecord", professionalContact);
        setFieldsData(targetRecord);
      } else {
        console.log("Medical History module not found");
      }
    } catch (error) {
      console.error("Error fetching all modules:", error);
    } finally {
      setLoading(false);
    }
  };
  console.log("contactlist", contactlist);
  useEffect(() => {
    getAttribute(props.activeStep.name);
    fetchAllModulesData();
    getContactsModule();
  }, []);
  useEffect(() => {
    if (fieldsData && fieldsData.id) {
      setToUpdate(true);
    }
  }, [fieldsData]);

  useEffect(() => {
    setTabs(Object.keys(fields));
  }, [fields]);
  console.log("fieldsData", fieldsData);

  return (
    <>
      <div className="main-contact-header-container" style={{ justifyContent: "space-between" }}>
        <div className="professional-contacts-container">
          <div className="professional-contact-title-container">
            <h2 className="professional-contact-title">Professional Contacts</h2>
          </div>
          <div className="professional-container-help-icon-container">
            <img src={helpIcon} alt="help-icon" width="18.67px" height="18.67px" />
          </div>
        </div>

        <div className="handle-submit-button-container">
          <button
            className="submit-button"
            onClick={() => history.push("/client/plan", { from: "/protector/disability" })}
          >
            Add Contact
          </button>
        </div>
      </div>

      <div className="input-fields-container">
        {tabs.length > 0 && (
          <>
            <DisabilityFormCreator
              data={fields["Professional Contacts"]}
              values={fieldsData}
              setSubmitBody={setFormData}
              contactsList={contactlist}
            />
          </>
        )}
        <NewLoader isLoading={loading} />
      </div>
      {!loading && fields && (
        <div className="handle-submit-button-container">
          <button
            className="submit-button"
            onClick={() => {
              if (toUpdate) {
                updateRecord();
              } else {
                createAttributes();
              }
            }}
          >
            {toUpdate ? "Update" : "Submit"}
          </button>
        </div>
      )}
    </>
  );
}
